module.exports = __webpack_public_path__ + "static/media/Night2.752cd17b.jpg";